exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-more-spots {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0.25rem;\n  border-radius: 32px;\n  text-align: center;\n  color: #333;\n  font-size: 13px;\n  margin-bottom: 2rem;\n  font-family: \"Plantin\", serif;\n}\n.loading-more-spots .icon-star {\n  animation-name: spin;\n  animation-duration: 5000ms;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n  margin-right: 10px;\n  width: 20px;\n  height: 20px;\n}\n@keyframes spin {\nfrom {\n    transform: rotate(0deg);\n}\nto {\n    transform: rotate(360deg);\n}\n}", ""]);

// exports
